export default "__VITE_ASSET__9ENVSFvh__"